import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";
export const OnlineResultsLogoSmall: React.FC<IconProps> = (props) => {
  const { fontSize } = {
    ...defaultIconProps,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="44"
      viewBox="0 0 32 44"
      fill="none"
      style={{ fontSize }}
      {...props}
    >
      <g clipPath="url(#clip0_6314_1921)">
        <path
          d="M15.963 0L0.517321 8.8L0 9.16975V28.1748L1.55196 28.9143L14.6328 35.274L15.963 35.9395V32.7597L2.80831 26.326L2.73441 10.7227L16.037 3.17983L29.2656 10.7227V26.326L15.963 40.2286V44L32 27.4353V9.0958L31.4827 8.8L15.963 0Z"
          fill="url(#paint0_linear_6314_1921)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6314_1921"
          x1="0"
          y1="21.9941"
          x2="32.0236"
          y2="21.9941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E50C52" />
          <stop offset="0.1607" stopColor="#E50C52" />
          <stop offset="0.4357" stopColor="#BC2170" />
          <stop offset="1" stopColor="#40A9E0" />
        </linearGradient>
        <clipPath id="clip0_6314_1921">
          <rect width="32" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
